import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState} from "react";


const pageLimit = parseInt(process.env.REACT_APP_PAGE_LIMIT);


function getPageFromUrl(url, isLast=false) {
    let offset;
    try {
        offset = parseInt([...url.matchAll(/offset=(\d+)/g)][0][1]);
        offset += isLast ? pageLimit : -pageLimit;
        return Math.floor(offset / pageLimit) + 1;
    } catch (e) {
        offset = pageLimit;
        return Math.ceil(offset / pageLimit) + 1;
    }
}

function getPage(next, previous) {
    if(previous === null) {
        return 1;
    }
    if (next === null) {
        return getPageFromUrl(previous, true);
    }
    return getPageFromUrl(next);

}

export default function Paginator({next, previous, count, toPageHandler}) {
    const [currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
        setCurrentPage(getPage(next, previous));
    }, [next, previous]);
    let totalPages = Math.ceil(count / pageLimit);

    const goNext = function () {
        toPageHandler(next)
    }

    const goLast = function() {
        toPageHandler(previous)
    }

    return (
    <div className="d-flex justify-content-center float-right right">
        <div className="link h5 chevron-left" onClick={goLast}><FontAwesomeIcon icon={faChevronLeft}/></div>
        &nbsp;
        {currentPage}/{totalPages}
        &nbsp;
        <div className="link h5 chevron-right" onClick={goNext}><FontAwesomeIcon icon={faChevronRight}/></div>
    </div>
    )
}